module.exports = __webpack_public_path__ + "static/media/layer-3-2.bf8ace93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scroll/layer-3-2.png
// module id = 424
// module chunks = 0